module.exports = __webpack_public_path__ + "static/media/dashboardSimple2_fr.ba071581.png";